var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.nameList ? _c("main", {
    staticClass: "hm-menu-category-x",
    style: {
      "--categoryTextHoverColor": _vm.formData.categoryTextHoverColor,
      "--categoryTextColor": _vm.formData.categoryTextColor,
      "--categoryBg": _vm.formData.categoryBg
    }
  }, _vm._l(_vm.nameList, function (item, index) {
    return _c("section", {
      key: index,
      staticClass: "hm-menu-category-item-x"
    }, [_c("div", {
      staticClass: "hm-menu-category-title"
    }, [_c("a", {
      ref: "categoryTitle",
      refInFor: true
    }, [_vm._v(" " + _vm._s(item.categoryName) + " ")]), _c("div", {
      staticClass: "hm-menu-category-title-after"
    })]), _vm._l(item.childrenList, function (child, index2) {
      return _c("p", {
        key: index2,
        staticClass: "hm-menu-category-item"
      }, [_c("a", {
        ref: "categoryItem" + index,
        refInFor: true,
        on: {
          click: _vm.onCategoryItemClick
        }
      }, [_vm._v(_vm._s(child.categoryName))])]);
    })], 2);
  }), 0) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };